import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { requestSinanStructure } from '../../../../services/sinanRequests';

const Criacao = ({ agravo, suspeita, dadosGerais, onChange }) => {
	const [formStructure, setFormStructure] = useState(null);
	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(true);
	const [titles, setTitles] = useState([]);

	useEffect(() => {
		fetchFormStructure();
	}, [agravo, suspeita]);

	const fetchFormStructure = async () => {
		try {
			const mockData = {
				related_name: 'dengue_chikungunya_individual',
				sections: {
					investigacao: {
						nome: 'Investigação',
						fields: [
							{
								name: 'dt_investigacao',
								type: 'DateField',
								required: false,
								null: true,
								label: 'Data da investigação',
							},
							{
								name: 'co_cbo_ocupacao',
								type: 'CharField',
								required: false,
								null: true,
								label: 'Ocupação profissional',
							},
						],
						subsections: {
							dados_clinicos: {
								nome: 'Dados Clínicos',
								fields: [],
								subsections: {
									sinais_clinicos: {
										nome: 'Sinais Clínicos',
										fields: [
											{
												name: 'febre',
												type: 'CharField',
												required: false,
												null: false,
												label: 'Febre',
												max_length: 1,
												choices: [
													{
														value: '1',
														label: 'Sim',
													},
													{
														value: '2',
														label: 'Não',
													},
												],
											},
											{
												name: 'cefaleia',
												type: 'CharField',
												required: false,
												null: false,
												label: 'Cefaleia',
												max_length: 1,
												choices: [
													{
														value: '1',
														label: 'Sim',
													},
													{
														value: '2',
														label: 'Não',
													},
												],
											},
											{
												name: 'vomito',
												type: 'CharField',
												required: false,
												null: false,
												label: 'Vômito',
												max_length: 1,
												choices: [
													{
														value: '1',
														label: 'Sim',
													},
													{
														value: '2',
														label: 'Não',
													},
												],
											},
											{
												name: 'mialgia',
												type: 'CharField',
												required: false,
												null: false,
												label: 'Mialgia',
												max_length: 1,
												choices: [
													{
														value: '1',
														label: 'Sim',
													},
													{
														value: '2',
														label: 'Não',
													},
												],
											},
										],
										subsections: {},
									},
									doencas_preexistentes: {
										nome: 'Doenças Pré-existentes',
										fields: [
											{
												name: 'diabetes',
												type: 'CharField',
												required: false,
												null: false,
												label: 'Diabetes',
												max_length: 1,
												choices: [
													{
														value: '1',
														label: 'Sim',
													},
													{
														value: '2',
														label: 'Não',
													},
													{
														value: '9',
														label: 'Ignorado',
													},
												],
											},
											{
												name: 'hipertensao',
												type: 'CharField',
												required: true,
												null: false,
												label: 'Hipertensão arterial',
												max_length: 1,
												choices: [
													{
														value: '1',
														label: 'Sim',
													},
													{
														value: '2',
														label: 'Não',
													},
													{
														value: '9',
														label: 'Ignorado',
													},
												],
											},
										],
										subsections: {},
									},
								},
							},
						},
					},
					conclusao: {
						nome: 'Conclusão',
						fields: [
							{
								name: 'classi_fin',
								type: 'CharField',
								required: true,
								null: false,
								label: 'Classificação Final',
								max_length: 2,
								choices: [
									{ value: '5', label: 'Descartado' },
									{ value: '10', label: 'Dengue' },
									{
										value: '11',
										label: 'Dengue com sinais de alarme',
									},
									{ value: '12', label: 'Dengue grave' },
									{ value: '13', label: 'Chikungunya' },
								],
							},
							{
								name: 'dt_encerramento',
								type: 'DateField',
								required: true,
								null: false,
								label: 'Data de encerramento',
							},
						],
						subsections: {},
					},
					observacoes: {
						nome: 'Observações',
						fields: [
							{
								name: 'ds_observacao',
								type: 'TextField',
								required: false,
								null: false,
								label: 'Observações adicionais',
								max_length: 255,
							},
						],
						subsections: {},
					},
				},
			};

			// lê token do cookie "user"
			const userCookie = Cookies.get('user');
			let token = null;

			if (userCookie) {
				try {
					const parsed = JSON.parse(userCookie);
					token = parsed?.token || null;
				} catch (err) {
					console.error(
						'Erro ao parsear cookie user para token:',
						err,
					);
				}
			}

			if (!token) {
				console.error(
					'Token não encontrado no cookie user para carregar estrutura SINAN',
				);
				setLoading(false);
				return;
			}

			const result = await requestSinanStructure(token);

			let currentTitles = [];

			Object.values(result?.sections).forEach((item) => {
				Object.values(item?.subsections)?.forEach((sub) => {
					currentTitles.push(sub.nome);
				});
			});

			if (!result.error) {
				setTitles(currentTitles);
				setFormStructure(result);
				initializeFormData(result);
				setLoading(false);
			}
		} catch (error) {
			console.error('Erro ao carregar estrutura do formulário:', error);
			setLoading(false);
		}
	};

	const initializeFormData = (structure) => {
		const initialData = {};

		const processFields = (fields) => {
			fields.forEach((field) => {
				initialData[field.name] = '';
			});
		};

		const processSection = (section) => {
			if (section.fields) {
				processFields(section.fields);
			}
			if (section.subsections) {
				Object.values(section.subsections).forEach(processSection);
			}
		};

		Object.values(structure.sections).forEach(processSection);
		setFormData(initialData);
		if (onChange) {
			onChange(initialData);
		}
	};

	const handleInputChange = (fieldName, value) => {
		setFormData((prev) => {
			const next = {
				...prev,
				[fieldName]: value,
			};
			if (onChange) {
				onChange(next);
			}
			return next;
		});

		if (errors[fieldName]) {
			setErrors((prev) => {
				const newErrors = { ...prev };
				delete newErrors[fieldName];
				return newErrors;
			});
		}
	};

	const validateForm = () => {
		const newErrors = {};

		const validateFields = (fields) => {
			fields.forEach((field) => {
				if (field.required && !formData[field.name]) {
					newErrors[field.name] = 'Campo obrigatório';
				}
			});
		};

		const validateSection = (section) => {
			if (section.fields) {
				validateFields(section.fields);
			}
			if (section.subsections) {
				Object.values(section.subsections).forEach(validateSection);
			}
		};

		if (formStructure) {
			Object.values(formStructure.sections).forEach(validateSection);
		}

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = () => {
		if (validateForm()) {
			console.log('Formulário válido! Dados:', formData);
			alert('Formulário enviado com sucesso!');
		} else {
			alert('Por favor, preencha todos os campos obrigatórios');
		}
	};

	const getErrorClass = (fieldName) => {
		return errors[fieldName]
			? 'border-2 border-red-500'
			: 'border border-[#E3E3E3]';
	};

	const shouldUseRadio = (field) => {
		return (
			field.choices &&
			field.choices.length > 0 &&
			field.choices.length <= 6
		);
	};

	const renderRadioField = (field) => {
		return (
			<div
				key={field.name}
				className={` ${getErrorClass(
					field.name,
				)} rounded-md p-2  w-full`}>
				<p className='mb-3 font-semibold'>
					{field.label}
					{field.required && <span className='text-red-500'> *</span>}
				</p>
				<div className={`rounded-lg  bg-white`}>
					<div className='flex flex-wrap gap-3'>
						{field.choices.map((choice) => (
							<label
								key={choice.value}
								className='flex items-center gap-2 cursor-pointer'>
								<input
									type='radio'
									name={field.name}
									value={choice.value}
									checked={
										formData[field.name] === choice.value
									}
									onChange={(e) =>
										handleInputChange(
											field.name,
											e.target.value,
										)
									}
									className='w-4 h-4 text-[#13335A] cursor-pointer'
								/>
								<span className='text-[#4F5257] text-sm'>
									{choice.label}
								</span>
							</label>
						))}
					</div>
				</div>
				{errors[field.name] && (
					<p className='text-red-500 text-xs mt-1'>
						{errors[field.name]}
					</p>
				)}
			</div>
		);
	};

	const renderField = (field) => {
		if (shouldUseRadio(field)) {
			return renderRadioField(field);
		}

		const baseClasses = `${getErrorClass(
			field.name,
		)} text-[#4F5257] h-[40px] px-1 rounded-[8px] w-full`;

		if (field.type === 'DateField') {
			return (
				<div
					key={field.name}
					className='w-full'>
					<p>
						{field.label}
						{field.required && (
							<span className='text-red-500'> *</span>
						)}
					</p>
					<input
						type='date'
						value={formData[field.name] || ''}
						onChange={(e) =>
							handleInputChange(field.name, e.target.value)
						}
						className={baseClasses}
					/>
					{errors[field.name] && (
						<p className='text-red-500 text-xs mt-1'>
							{errors[field.name]}
						</p>
					)}
				</div>
			);
		}

		if (field.choices && field.choices.length > 0) {
			return (
				<div
					key={field.name}
					className='w-full'>
					<p>
						{field.label}
						{field.required && (
							<span className='text-red-500'> *</span>
						)}
					</p>
					<select
						value={formData[field.name] || ''}
						onChange={(e) =>
							handleInputChange(field.name, e.target.value)
						}
						className={baseClasses}>
						<option
							hidden
							disabled
							value=''>
							Selecione
						</option>
						{field.choices.map((choice) => (
							<option
								key={choice.value}
								value={choice.value}>
								{choice.label}
							</option>
						))}
					</select>
					{errors[field.name] && (
						<p className='text-red-500 text-xs mt-1'>
							{errors[field.name]}
						</p>
					)}
				</div>
			);
		}

		if (field.type === 'TextField') {
			return (
				<div
					key={field.name}
					className='w-full'>
					<p>
						{field.label}
						{field.required && (
							<span className='text-red-500'> *</span>
						)}
					</p>
					<div
						className={`text-sm border-[#E3E3E3] w-full text-[#13335A] py-1 px-2 rounded-[8px] ${getErrorClass(
							field.name,
						)}`}>
						<textarea
							className='w-full text-[#4F5257] h-[80px] resize-none focus:outline-none placeholder-[#E3E3E3]'
							value={formData[field.name] || ''}
							onChange={(e) =>
								handleInputChange(field.name, e.target.value)
							}
							placeholder={field.label}
							maxLength={field.max_length}
						/>
					</div>
					{errors[field.name] && (
						<p className='text-red-500 text-xs mt-1'>
							{errors[field.name]}
						</p>
					)}
				</div>
			);
		}

		return (
			<div
				key={field.name}
				className='w-full'>
				<p>
					{field.label}
					{field.required && <span className='text-red-500'> *</span>}
				</p>
				<input
					type='text'
					placeholder={field.label}
					value={formData[field.name] || ''}
					onChange={(e) =>
						handleInputChange(field.name, e.target.value)
					}
					className={`${baseClasses} placeholder-[#E3E3E3]`}
					maxLength={field.max_length}
				/>
				{errors[field.name] && (
					<p className='text-red-500 text-xs mt-1'>
						{errors[field.name]}
					</p>
				)}
			</div>
		);
	};

	const renderSubsection = (subsection, key) => {
		return (
			<div
				key={key}
				className={` ${
					titles.includes(subsection.nome)
						? ' rounded-t-md mt-4 rounded-md  border border-[#E3E3E3]'
						: ' border-[1px] border-[#E3E3E3] rounded-md px-2 py-1'
				} font-semibold text-[#13335A] mb-3 text-base`}>
				<h3
					className={` ${
						titles.includes(subsection.nome)
							? 'bg-[#f7f7f7] p-2 rounded-t-md mb-2'
							: ''
					} font-semibold text-[#13335A] mb-[8px ] text-base`}>
					{titles.includes(subsection.nome)
						? subsection.nome.toUpperCase()
						: subsection.nome}
				</h3>
				<div
					className={`
            ${titles.includes(subsection.nome) ? 'px-2' : ''}
            text-sm text-[#13335A] w-full mb-2
            grid gap-2
            lg:grid-cols-4
            md:grid-cols-4
            sm:grid-cols-3
            grid-cols-2
              `}>
					{/* 	{console.log(Object.values(subsection.subsections).length)} */}

					{subsection.fields.map((field) => (
						<div
							key={field.name}
							className={`${
								shouldUseRadio(field)
									? ''
									: 'flex-1 min-w-[212px]'
							}`}>
							{renderField(field)}
						</div>
					))}
				</div>
				{subsection.subsections &&
					Object.keys(subsection.subsections).length > 0 && (
						<div className='px-2'>
							{Object.entries(subsection.subsections).map(
								([subKey, subSection]) =>
									renderSubsection(subSection, subKey),
							)}
						</div>
					)}
			</div>
		);
	};

	const renderSection = (section, key) => {
		return (
			<div
				key={key}
				className='rounded-md border border-[#E3E3E3] overflow-hidden  mb-2'
				onClick={(e) => {
					const content =
						e.currentTarget.querySelector('.conteudo-oculto');
					content.classList.toggle('max-h-0');
					content.classList.toggle('max-h-[3000px]');
					content.classList.toggle('py-0');
					content.classList.toggle('py-2');
				}}>
				<div className=' text-[#13335A] font-semibold rounded-t-md p-2 cursor-pointer select-none bg-[#f7f7f7]'>
					{section.nome.toUpperCase()}
				</div>

				<div
					className='conteudo-oculto max-h-0 transition-all duration-500 ease-in-out py-0 px-2 overflow-hidden'
					onClick={(e) => e.stopPropagation()}>
					{section.fields.length > 0 && (
						<div className='text-sm text-[#13335A] w-full flex flex-wrap lg:flex-row flex-col gap-4  lg:gap-6'>
							{section.fields.map((field) => (
								<div
									key={field.name}
									className={`${
										shouldUseRadio(field)
											? 'w-full'
											: 'flex-1 min-w-[250px]  lg:min-w-[300px]'
									}`}>
									{renderField(field)}
								</div>
							))}
						</div>
					)}

					{section.subsections &&
						Object.keys(section.subsections).length > 0 && (
							<>
								{section.fields.length > 0 && (
									<hr className='my-3' />
								)}
								{Object.entries(section.subsections).map(
									([subKey, subSection]) =>
										renderSubsection(subSection, subKey),
								)}
							</>
						)}
				</div>
			</div>
		);
	};

	if (loading) {
		return (
			<div className='flex items-center justify-center min-h-screen'>
				<div className='text-[#13335A] text-xl'>
					Carregando formulário...
				</div>
			</div>
		);
	}

	if (!formStructure) {
		return (
			<div className='flex items-center justify-center min-h-screen'>
				<div className='text-red-500 text-xl font-inter font-semibold'>
					Erro ao carregar formulário
				</div>
			</div>
		);
	}

	return (
		<div className='bg-white '>
			<div>
				{Object.entries(formStructure.sections).map(([key, section]) =>
					renderSection(section, key),
				)}

				{/* 	<div className='flex gap-4 mt-6 px-2'>
					<button
						onClick={handleSubmit}
						className='bg-[#13335A] text-white px-6 py-3 rounded-lg hover:bg-[#1a4470] transition-colors font-semibold'>
						Enviar Formulário
					</button>
					<button
						onClick={() => {
							setFormData({});
							setErrors({});
							initializeFormData(formStructure);
						}}
						className='bg-gray-300 text-[#13335A] px-6 py-3 rounded-lg hover:bg-gray-400 transition-colors font-semibold'>
						Limpar Formulário
					</button>
				</div> */}
			</div>
		</div>
	);
};

export default Criacao;
